import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { ChipCheckerResults, PetService } from 'src/app/services/pet/pet.service';

@Component({
  selector: 'app-footer-cards',
  templateUrl: './footer-cards.component.html',
  styleUrls: ['./footer-cards.component.scss']
})
export class FooterCardsComponent implements OnInit {
  chipCheckerLoading = false;
  chipCheckerResults: ChipCheckerResults = null;
  chipCheckerNumber: string;
  brandName: string;
  showHelpCenterSection: boolean;

  constructor(
    private petService: PetService,
    private configService: ConfigService
  ) {
    this.brandName = this.configService.getTextFromKey('brand-name');
    this.showHelpCenterSection = this.configService.getFeatureFlag('showHelpCenterSection');
  }

  checkChip() {
    this.chipCheckerLoading = true;
    this.chipCheckerResults = null;
    this.petService.checkChip(this.chipCheckerNumber)
      .subscribe(
        results => {
          this.chipCheckerResults = results;
        }
      )
      .add(() => {
        this.chipCheckerLoading = false;
      });
  }

  ngOnInit(): void {}
}
